import { render, staticRenderFns } from "./Inhalt.vue?vue&type=template&id=17213c8d&scoped=true&"
import script from "./Inhalt.vue?vue&type=script&lang=js&"
export * from "./Inhalt.vue?vue&type=script&lang=js&"
import style0 from "./Inhalt.vue?vue&type=style&index=0&id=17213c8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17213c8d",
  null
  
)

export default component.exports